import React from "react";
import "./SummaryCard.scss";

function SummaryCard({
  title,
  firstValue = 2,
  secondValue = 10,
  titleColor = "black",
  backgroundColor = "#FFFFFF",
  borderColor = "#BEFBDD80",
}: {
  title: string;
  firstValue?: number;
  secondValue?: number;
  titleColor?: string;
  backgroundColor?: string;
  borderColor?: string;
}) {
  return (
    <div
      className="summary-card"
      style={{
        borderColor: borderColor,
        backgroundColor: backgroundColor,
      }}
    >
      <span 
        className="summary-card__title"
        style={{ color: titleColor }}
      >
        {title}
      </span>
      <h2 className="summary-card__value">
        {firstValue}/{secondValue}
      </h2>
    </div>
  );
}

export default SummaryCard;